const PRIVACY_SELECTED = 'PRIVACY_SELECTED';
const TERMS_OF_SERVICE_SELECTED = 'TERMS_OF_SERVICE_SELECTED';

export { PRIVACY_SELECTED, TERMS_OF_SERVICE_SELECTED };
